import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import PlayersMyPicksTab from "../../components/PlayersMyPickTab/PlayersMyPicksTab";
import ParlayRenderer from "../../components/ParlayRenderer/ParlayRenderer";
import FilterBarMobile from "../../components/FilterBar/FilterBar.Mobile";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import {FormattedMessage} from "react-intl";
import ContestPick from "../../components/ContestPick/ContestPick";
import CreateYourOwnPicksBanner from "../../components/ParlayRenderer/renderers/CreateYourOwnParlayRenderer/CreateYourOwnPicksBanner";
import usePreSubmitParlayService from "../../services/hooks/usePreSubmitParlayService";

const mobileViewMode = {
    PLAYERS: 0,
    MY_PICKS: 1
};

const CreateOwnParlayViewMobile = ({vm, setScrollPosition, scrollPosition})=>{
    const [isFilterBarOpen, setFilterBarOpen] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const myPicks = queryParams.get('myPicks');

    const [viewMode, setViewMode] = useState(myPicks=== "1" ? mobileViewMode.MY_PICKS : mobileViewMode.PLAYERS);
    const parlayContests = vm.selectedParlay?.contestIds
        ?.map(id => vm.viewData.contestsMap.get(id))
        .filter(Boolean) ?? [];

    const {submitParlay, disableSubmitParlay} = usePreSubmitParlayService({
        parlay: vm.selectedParlay,
        contests: parlayContests,
        selectedEntryFee: vm.selectedParlay?.Wager,
        focusToFeeInput: () => {},
    });

    const handleTabClick = (selectedVieMode)=>{
        if(viewMode === mobileViewMode.PLAYERS){
            setScrollPosition(window.scrollY)
        }
        setViewMode(selectedVieMode);
    };

    useEffect(() => {
        if (viewMode === mobileViewMode.PLAYERS) {
            window.scrollTo({
                top: scrollPosition,
                behavior: 'instant',
            });
        }
    }, [viewMode]);

    return (<div className="CreateOwnParlayView mobile">
            <PlayersMyPicksTab onTabClick={(selectedVieMode)=>handleTabClick(selectedVieMode)}
                               viewModes={mobileViewMode}
                               viewMode={viewMode}/>
            {viewMode === mobileViewMode.MY_PICKS &&
                <ParlayRenderer parlay={vm.selectedParlay}/>
            }
            {viewMode === mobileViewMode.PLAYERS &&
                <CreateYourOwnPicksBanner parlay={vm.selectedParlay}
                                          contests={parlayContests}
                                          onViewPicks={() => handleTabClick(mobileViewMode.MY_PICKS)}
                                          onSubmit={async () => {
                                              handleTabClick(mobileViewMode.MY_PICKS);
                                              await submitParlay();
                                          }}
                                          disableSubmit={disableSubmitParlay}/>
            }
            {viewMode === mobileViewMode.PLAYERS &&
                <div className="customContestCardList">
                    <FilterBarMobile vm={vm}
                                     isFilterBarOpen={isFilterBarOpen}
                                     setFilterBarOpen={setFilterBarOpen}/>
                    {vm.isLoading &&<div className="loading">{<LoadingSpinner/>}</div>}
                    {vm.filteredContests.length === 0 && !vm.isLoading ?
                        <div className="noPlayers"><FormattedMessage id={"lobbyView.createOwnParlayView.noPlayers"}/></div>
                        :
                        <div className="cards">
                            {vm.filteredContests?.map((contest) => (
                                <ContestPick key={contest.Id}
                                             contest={contest}
                                             parlay={vm.selectedParlay}
                                             disabled={!vm.canAdd(contest.Id)}
                                />
                            ))}
                        </div>}
                </div>}
        </div>
    )
}

export default CreateOwnParlayViewMobile;
